export const SIZE_DEVICE = {
  // mobileS: '320px',
  // mobileM: '375px',
  // mobileL: '425px',
  // tablet: '768px',
  laptop: '1024px',
  // laptopL: '1440px',
  desktop: '2560px',
  mobile: '599px',
};

export const DEVICE = {
  desktopOnly: `(min-width:${SIZE_DEVICE.mobile}) and (max-width: ${SIZE_DEVICE.desktop})`,
  laptopOnly: `(min-width:${SIZE_DEVICE.mobile}) and (max-width: ${SIZE_DEVICE.laptop})`,
  mobileOnly: `(max-width: ${SIZE_DEVICE.mobile})`,
  laptop: `(max-width: ${SIZE_DEVICE.laptop})`,
};
